module.exports = __webpack_public_path__ + "static/img/362.bcbbc391.png";